export const site = {
  name: "CodeWithT",
  shortName: "CodeWithT",
  url: "https://codewitht.com",
  description:
    "Tony Habib — Senior Software Engineer & University Lecturer. I build custom web applications for businesses and mentor students and junior developers preparing for tech careers.",
  copyright: "Copyright © by Codewitht | All Rights Reserved",
  socials: {
    instagram: "https://www.instagram.com/code.with.t",
    linkedin: "https://www.linkedin.com/in/tony-habib-5747b11b1/",
    phone: "+96170455015",
    phoneDisplay: "+961 70 455015",
  },
};
